import './scss/main.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { VueHammer } from 'vue2-hammer'

VueHammer.config.swipe = {
    threshold: 10,
    velocity: 0.05,
};

Vue.use(VueHammer)

import './filters'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
